import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

export async function simulateInvoice(accessKey) {
  const url = new URL(`/nfe/${accessKey}/simulate`, API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Não foi possível conectar ao servidor. Verifique se o backend está ativo.");
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao simular fatura"));
  }

  return data;
}
